import Vue from 'vue'
// import App from './App.vue'
// import Form from './Form.vue'
import AxiosPlugin from "./Plugin/AxiosPlugin"
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto'
import Notifications from 'vue-notification'
import BootstrapVue from 'bootstrap-vue'
import Util from "./Plugin/Util";
import Modal from "./components/Util/Modal"

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(VueScrollTo)
Vue.use(AxiosPlugin)
Vue.use(Notifications)
Vue.use(Modal)
Vue.use(BootstrapVue)
Vue.use(Util)

// Vee-Validate
import VeeValidate, {Validator} from 'vee-validate'
import it from 'vee-validate/dist/locale/it'


Vue.use(VeeValidate);
Validator.localize('it', it);

const phone = {
    getMessage: `Inserisci un numero di telefono valido`,
    validate(value) {
        const reg = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
        return reg.test(value) && value.length > 8
    }
}
Validator.extend('phone', phone)

const nospecial = {
    getMessage: `Non puoi inserire caratteri speciali`,
    validate(value) {
        const reg = /^[_A-z0-9]*((-|'|\s)*[_A-z0-9])*$/
        return reg.test(value.trim())
    }
}
Validator.extend('nospecial', nospecial)

const name = {
    getMessage: `Non puoi inserire caratteri speciali/numeri, minimo 2 caratteri`,
    validate(value) {
        if (value.length <= 0) return true
        const reg = /^[\w'\-,.][^0-9_!¡?÷/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/
        return reg.test(value.trim())
    }
}
Validator.extend('name', name)

import Form from "./Form";
import {store} from "./store/store"
import router from "./router/router"

new Vue({
    render: h => h(Form),
    store,
    router,
    mounted() {
        this.$http.defaults.headers.common['X-CSRFToken'] = this.$cookies.get('csrftoken')
        this.$store.dispatch('race_data')
        this.$store.commit('vue', {
            '$http': this.$http,
            '$notify': this.$notify,
            '$cookies': this.$cookies,
            '$modal': this.$modal
        })
    }
}).$mount('#race-form')
